export const fetchErrorMessage =
  "Your browser encountered an error processing this request. Please check your internet connection and try again. If this problem persists, then please contact us at support@dogalog.dog.";
export const generalErrorMessage =
  "There was an unknown server error while processing your request. If this problem persists, then please contact us at support@dogalog.dog.";
